import useCompanyTier from './useCompanyTier';

/**
 * Easy Mode is limited to Diamond-tier firms. A build-level kill switch
 * (VITE_ENABLE_EASY_MODE=false) can turn it off everywhere; it defaults on.
 * @returns {boolean} whether Easy Mode should be shown to the current user
 */
const useEasyModeFeatureFlag = () => {
  const { isDiamondTier } = useCompanyTier();
  const isEnabledForBuild = import.meta.env.VITE_ENABLE_EASY_MODE !== 'false';

  return isEnabledForBuild && isDiamondTier;
};

export default useEasyModeFeatureFlag;
